import { useEffect, useState } from "react";

import AlertComponent from "../../../helpers/alert/AlertComponent";
import { getAlertedProductsCentralizacion } from "../../../entities/alerted-product";

// Consume /api/alertas/centralizacion?orden_detalle_id= para alimentar las
// secciones "Información de Orden de Compra" y "Gestión de Levantamiento" del
// detalle de Centralización.
export const useCentralizationDetalle = (ordenDetalleId) => {
  const [detalle, setDetalle] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!ordenDetalleId) {
      setDetalle(null);
      return undefined;
    }

    let cancelled = false;
    const fetchDetalle = async () => {
      setLoading(true);
      try {
        const result = await getAlertedProductsCentralizacion(ordenDetalleId);
        if (!cancelled) setDetalle(result);
      } catch {
        if (cancelled) return;
        setDetalle(null);
        AlertComponent.error(
          "Error",
          "No fue posible cargar el detalle de centralización"
        );
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDetalle();
    return () => {
      cancelled = true;
    };
  }, [ordenDetalleId]);

  return { detalle, loading };
};